<template>
  <v-form class="third-party-works-info">
    <label class="input-label">Tytuł utworu:</label>
    <v-text-field
      :value="thirdPartyWork.title"
      v-bind="props.disabledInput"
      class="third-party-works-info__input"
    />
    <label class="input-label">Autor utworu:</label>
    <v-text-field
      :value="thirdPartyWork.author"
      v-bind="props.disabledInput"
      class="third-party-works-info__input"
    />
    <label class="input-label">Informacje o prawach:</label>
    <v-textarea
      :value="thirdPartyWork.info"
      v-bind="props.disabledInput"
      height="false"
      no-resize
      class="third-party-works-info__input third-party-works-info__textarea"
    />
  </v-form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import props from '@/helpers/componentsProps';

export default {
  props: {
    id: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      props,
      thirdPartyWork: {},
    };
  },

  computed: {
    ...mapGetters('metrics', [
      'getThirdPartyWorksSingle',
    ]),
  },

  created() {
    this.thirdPartyWork = { ...this.getThirdPartyWorksSingle(this.id) };
  },
};
</script>

<style lang="scss" scoped>
.third-party-works-info {
  width:100%;
  &__input {
    margin-bottom:16px;
  }
  &__textarea::v-deep textarea {
    padding: 0 !important;
  }
}
</style>
